import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var getDirections16Icon = /*#__PURE__*/React.createElement("svg", {
  height: "16",
  width: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.92 4.12c.2.198.27.493.18.76L8.71 15.23a.75.75 0 0 1-.69.52H8a.76.76 0 0 1-.7-.47l-1.88-4.7L.72 8.7A.76.76 0 0 1 .25 8a.74.74 0 0 1 .52-.68l10.39-3.39a.76.76 0 0 1 .76.19Zm-1.7 1.68L3.21 8.08 6.28 9.3c.19.08.34.23.42.42l1.23 3.08 2.29-7Zm5.53-1.3A4.18 4.18 0 0 0 15 2.13 3.92 3.92 0 0 0 13.89 1 4.15 4.15 0 0 0 11.5.25a4.23 4.23 0 0 0-4.08 3.09L8 3.5a1 1 0 0 0 1.14-.42 2.76 2.76 0 0 1 2.36-1.33 2.64 2.64 0 0 1 1.55.49c.29.188.536.437.72.73a2.6 2.6 0 0 1 .48 1.53 2.76 2.76 0 0 1-1.33 2.36A1 1 0 0 0 12.5 8l.16.58a4.23 4.23 0 0 0 3.09-4.08Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { getDirections16Icon as default };
//# sourceMappingURL=getDirections16Icon.js.map
